import React from "react";
import _ from "lodash";
import glamorous from "glamorous";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import ReactTable from "react-table";

import { LadChicletCSS as Chiclet } from "../../components/chiclets";
import "./tabs-selected.css";
import Colors from "../../styles/colors";
import { getLadName, LOBS } from "../../components/lads";
import LadLabelForm from "./LadLabelForm";

const CHICLET_HEIGHT = 60;

const LocationTypeCellRenderer = props => {
  const { updateLadLabel, ...lad } = props.value;
  const originalLabel = getLadName(lad);
  return (
    <glamorous.Div display="flex" flexDirection="row">
      <glamorous.Div marginLeft="1em">
        <Chiclet
          lad={lad}
          height={CHICLET_HEIGHT}
          width={CHICLET_HEIGHT}
          showLadLabel
        />
      </glamorous.Div>
      <LadLabelForm
        lad={lad}
        height={CHICLET_HEIGHT}
        originalLabel={originalLabel}
        updateLadLabel={updateLadLabel}
      />
    </glamorous.Div>
  );
};

const LadDefinitionCellRenderer = props => {
  const definitionText = props.value;
  return (
    <glamorous.Div
      color={Colors.editLadsLabelText}
      whiteSpace="normal"
      paddingLeft="1em"
    >
      {definitionText}
    </glamorous.Div>
  );
};

const ColHeadThStyles = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  textAlign: "left",
  color: Colors.editLadsLabelText,
  backgroundColor: "white",
  height: "50px",
  paddingLeft: "1em"
};

const connectedLadEditColumns = updateLadLabel => [
  {
    Header: "Location types",
    id: "code-name-chiclet",
    accessor: d => ({
      updateLadLabel,
      ...d
    }),
    Cell: LocationTypeCellRenderer
  },
  {
    Header: "Definition",
    accessor: "description",
    Cell: LadDefinitionCellRenderer
  }
];

const EditLadsView = ({ ladsGrouped, updateLadLabel }) => {
  const lobs = LOBS;
  const tabs = _.map(lobs, lobName => (
    <Tab
      key={`${lobName}-tab`}
      style={{
        flex: 1,
        textAlign: "center",
        fontSize: "1.2em",
        height: "3em",
        paddingTop: "0.75em",
        marginRight: "0.5em"
      }}
    >
      {lobName}
    </Tab>
  ));

  const columns = connectedLadEditColumns(updateLadLabel);
  const tabPanels = _.map(lobs, lobName => {
    if (lobName in ladsGrouped) {
      return (
        <TabPanel key={`${lobName}-panel`}>
          <ReactTable
            data={ladsGrouped[lobName]}
            columns={columns}
            getTheadThProps={() => ({ style: ColHeadThStyles })}
          />
        </TabPanel>
      );
    } else {
      return <TabPanel key={`${lobName}-panel`} />;
    }
  });

  return (
    <div>
      <Tabs>
        <TabList
          style={{
            marginTop: "1em",
            marginBottom: 0,
            display: "flex",
            border: "none"
          }}
        >
          {tabs}
        </TabList>
        {tabPanels}
      </Tabs>
    </div>
  );
};

export default EditLadsView;



// WEBPACK FOOTER //
// ./src/modules/lads/EditLadsView.js